// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__359wG","right":"Footer_right__1HXEJ","buttons":"Footer_buttons__CZPpF"};